module.exports = __webpack_public_path__ + "static/img/GR@3x.a9d85618.jpg";